<div class="container signup-container">
  <acc-main-error-dialog [cssClass]="'signup'" *ngIf="errorMessage$ | async" [message]="errorMessage$ | async"></acc-main-error-dialog>
  <router-outlet></router-outlet>
</div>
